exports.chunksAccounts = (arr, limit = 4000) => {
  let contador = 1;

  return arr.reduce((p, c, index) => {
    if (index + 1 > contador * limit) contador++;
    if (!p[contador - 1]) p[contador - 1] = [c];
    else p[contador - 1].push(c);
    return p;
  }, []);
};
